import React, { useEffect, useState, useRef } from 'react';
import { Container } from "react-bootstrap";
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import Axios from '../../lib/axios/axiosInstance';
import ReactToPrint from "react-to-print";
import Loader from '../Common/loader';

const InvoiceDetails = () => { 
    const navigate = useNavigate();
    let componentRef = useRef();
    const [searchParams, setSearchParams] = useSearchParams();
    const [InvDetails, setInvDetails] = useState(false);

    useEffect(async () => {
        const invoicenum = searchParams.get("invoicenum")
        if (invoicenum) {
            // Get Invoice Details
            // api/account/invoice/:invoicenum
            await Axios.get(`/account/invoice/${invoicenum}`)
                .then(function (response) {
                    if (response && response.data?.data) {
                        setInvDetails(response.data?.data)
                    }
                })
        }
    }, [searchParams])

    const DetailsDiv = ({ nRef, hide }) => {
        return (
            <div className="col-main" ref={nRef}>
                <div className="shopping-cart-inner">
                    <div className="page-content">
                        <div className="page-content checkout-page">
                            <div className="box-border">
                                <h2>{"Invoice Details"}</h2>
                                <h3 className="checkout-sep" style={{ paddingBottom: "10px" }}>Invoice NO : {InvDetails?.invoice?.invoicenum}</h3>
                                <h5><strong>Invoice Date:</strong> {InvDetails?.invoice?.invoicedate}</h5>
                                <h5><strong>Order NO:</strong> {InvDetails?.invoice?.ordernum}</h5>
                                <h5><strong>PO NO:</strong> {InvDetails?.invoice?.ponum}</h5>
                                <br />
                                <div className="order-detail-content table-responsive">
                                    <table className="table table-bordered jtv-cart-summary">
                                        <thead>
                                            <tr>
                                                <th className="cart_product">Product Code</th>
                                                <th>Description</th>
                                                <th>Unit price</th>
                                                <th>Qty</th>
                                                <th>Total</th>
                                            </tr>
                                        </thead>
                                        {InvDetails && InvDetails.items ?
                                            <>
                                                <tbody>

                                                    {InvDetails.items.map((item, i) => {
                                                        return (
                                                            <tr key={i}>
                                                                <td className="cart_product">
                                                                    {/* <Link to="/order-details">
                            <img src={AuthVerify.getImageLink(item?.imageurl)} alt="Product" /></Link> */}
                                                                    {item.matnum}</td>
                                                                <td className="cart_description"><p className="product-name">{hide?item?.matname:<Link to={"/product-detail?matnum="+item?.matnum}> {item?.matname}</Link>}</p></td>
                                                                <td className="price"><span>S${item.uprice}</span></td>
                                                                <td className="price"><span>{item.qty}</span></td>
                                                                <td className="price"><span>S${item.amt}</span></td>
                                                            </tr>)
                                                    })}
                                                </tbody>

                                                <tfoot>
                                                    <tr>
                                                        <td colSpan="4"><strong>Discount</strong></td>
                                                        <td colSpan="1"><strong>S${(InvDetails?.invoice?.discamt ?? 0).toFixed(3)}</strong></td>
                                                    </tr>
                                                    <tr>
                                                        <td colSpan="4"><strong>Shipping Amount</strong></td>
                                                        <td colSpan="1"><strong>S${(InvDetails?.invoice?.shippingamt ?? 0).toFixed(3)}</strong></td>
                                                    </tr>
                                                    <tr>
                                                        <td colSpan="4"><strong>GST</strong></td>
                                                        <td colSpan="1"><strong>S${(InvDetails?.invoice?.gstamt ?? 0).toFixed(3)}</strong></td>
                                                    </tr>
                                                    <tr>
                                                        <td colSpan="4"><strong>Grand Total</strong></td>
                                                        <td colSpan="1"><strong>S${(InvDetails?.invoice?.total ?? 0).toFixed(3)}</strong></td>
                                                    </tr>
                                                    <tr>
                                                        <td colSpan="4"><strong>Paid</strong></td>
                                                        <td colSpan="1"><strong>S${(InvDetails?.invoice?.paid ?? 0).toFixed(3)}</strong></td>
                                                    </tr>
                                                    <tr>
                                                        <td colSpan="4"><strong>Outstanding</strong></td>
                                                        <td colSpan="1"><strong>S${(InvDetails?.invoice?.totalamt ?? 0).toFixed(3)}</strong></td>
                                                    </tr>
                                                </tfoot>
                                            </> :
                                            <tr>
                                                {InvDetails.items != null ? <td colSpan="6"><Loader /></td> : <td colSpan="6" style={{ textAlign: 'center' }}>No products found !</td>}
                                            </tr>
                                        }
                                    </table>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>)
    }

    return (
        <section className="main-container col1-layout">
            <Container className="main">

                <DetailsDiv/>
                <div style={{display:'none'}}><DetailsDiv nRef={componentRef} hide={true}/></div>
                <div className="cart_navigation" style={{ marginBottom: '10px' }}>
                    <button className="button btn-proceed-checkout" title="Reorder" type="button" onClick={() => navigate('/my-account?activeKey=Invoices')}><span>Return to Invoice Listing</span></button>
                    <ReactToPrint
                        trigger={() => <button className="button btn-proceed-checkout" type="button">
                            <span>Print Invoice</span>
                        </button>}
                        content={() => componentRef.current}
                    />
                </div>
            </Container >
        </section >
    )
}
export default InvoiceDetails;

